import React, {Component} from 'react';
import VimeoEmbed from '../../../components/VimeoEmbed/VimeoEmbed';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import ReasonsResults from '../../../components/Reasons/ReasonsResults';
import getOpenEnrollmentDates from '../../../helpers/openEnrollment';
import Aux from '../../../components/Hoc/Aux';

import iconBill from '../../../assets/svg/icon-bill.svg';
import iconPrescription from '../../../assets/svg/icon-prescription.svg';
import iconPocket from '../../../assets/svg/icon-pocket.svg';

class MedicareWesternNY extends Component {
  state = {
    headerHeight: 100
  }

  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Prospect - Individual Medicare WNY',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Medicare WNY',
      'eventValue': undefined
    });

    this.props.updateTopBanner(this.checkDate());
  }

  getHeaderHeight = (height) => {
    this.setState({headerHeight: height});
  }

  checkDate = () => {
    return getOpenEnrollmentDates();
  }

  render () {
    // const guideTitle = 'The Top 5 Mistakes People Make When Selecting a Medicare Plan';
    // const p = _.clone(this.props);
    return (
      <Aux>
        <section className='p60'>
          <div className='wrap'>
            <h2>Because Original Medicare doesn&rsquo;t cover&nbsp;everything.</h2>
            <h4>It provides basic Hospital (Part A) and Medical (Part B) coverage, but does not<br /> protect against certain costs that can add up quickly: </h4>
            <ul className='three-col reasons'>
              <li className='col'>
                <span><img src={iconBill} alt='20% of medical costs' /></span>
                <p>You’re typically responsible for 20% of medical costs</p>
              </li>
              <li className='col'>
                <span><img src={iconPrescription} alt='Limited coverage' /></span>
                <p>No drug, vision, dental, or global emergency coverage</p>
              </li>
              <li className='col'>
                <span><img src={iconPocket} alt='Out-of-pocket costs' /></span>
                <p>No limit on your<br /> out-of-pocket costs</p>
              </li>
            </ul>
          </div>
          <div id='video'>&nbsp;</div>
          <div className='wrap sm'>
            <VimeoEmbed videoId='1215229413' hash='bd848bae19' title='CDPHP Medicare 101' />
          </div>
        </section>

        <ReasonsResults
          divide='divide'
          intro='true'
          type='medicare'
        />

        <DocSearch search='https://findadoc.cdphp.com/?PlanType=Medicare HMO' wny='true' />
      </Aux>
    );
  }
}

MedicareWesternNY.propTypes = { // validate props expected
};

export default MedicareWesternNY;
